import { useEffect, useState } from "react";
import { useDebounced } from "@/utils";

/** Local search input synced to URL state after debounce; external clears win over stale drafts. */
export function useSyncedDebouncedSearch(search: string, setSearch: (value: string) => void) {
  const [searchInput, setSearchInput] = useState(search);
  const [prevSearch, setPrevSearch] = useState(search);
  const debouncedSearch = useDebounced(searchInput, 400);

  if (search !== prevSearch) {
    setPrevSearch(search);
    setSearchInput(search);
  }

  useEffect(() => {
    // Wait until debounce catches up so a stale draft can't overwrite an external clear.
    if (debouncedSearch !== searchInput) return;
    if (debouncedSearch === search) return;
    setSearch(debouncedSearch);
  }, [debouncedSearch, searchInput, search, setSearch]);

  return [searchInput, setSearchInput] as const;
}
